import { EMAIL_BASE_ASSET_PATH } from '../constants.js';
export const splineExpertPartnership = {
    applicationUrl: 'https://spline.design/contra',
    displayName: 'Spline',
    emailDetails: {
        expertPartnerLogoImageUrl: `${EMAIL_BASE_ASSET_PATH}logos/spline.jpg`,
        heroImageUrl: `${EMAIL_BASE_ASSET_PATH}social-wall.webp`,
    },
    matching: {
        outcomes: ['3D_DESIGNS'],
        roles: ['Spline Designer'],
        tools: ['Spline'],
    },
    name: 'spline',
    pageDescription: 'Looking for a Spline expert for your next website project? Browse and get in touch with Spline freelancers on Contra to find the skills you need.',
    pageTitle: 'Hire Spline Experts for Your 3D Website Project',
    released: true,
    route: '/spline',
    userGroup: 'SPLINE_EXPERT',
};
//# sourceMappingURL=spline.js.map